import {
  MAC_ALT_KEY,
  MAC_COMMAND_KEY,
  MAC_CTRL_KEY,
  OS_ALT_KEY,
  OS_COMMAND_KEY,
  OS_CTRL_KEY,
  WINDOWS_ALT_KEY,
  WINDOWS_COMMAND_KEY,
  WINDOWS_CTRL_KEY,
} from './single-keys';

export const maybeMapCombinationKey = (args: {
  key: string;
  nonMappedKeyToUpperCase?: boolean;
  os?: 'mac' | 'windows';
}) => {
  const hotKey = combinationKeyMap[args.key];
  const osHotKey = hotKey ? hotKey[args.os || 'default'] : undefined;

  return (
    osHotKey ||
    (args.nonMappedKeyToUpperCase ? args.key.toUpperCase() : args.key)
  );
};

const combinationKeyMap: Record<
  string,
  {
    mac: string;
    windows: string;
    default: string;
  }
> = {
  Control: {
    windows: WINDOWS_CTRL_KEY,
    mac: MAC_CTRL_KEY,
    default: OS_CTRL_KEY,
  },
  Meta: {
    windows: WINDOWS_COMMAND_KEY,
    mac: MAC_COMMAND_KEY,
    default: OS_COMMAND_KEY,
  },
  Alt: {
    windows: WINDOWS_ALT_KEY,
    mac: MAC_ALT_KEY,
    default: OS_ALT_KEY,
  },
};
